import { CONVERSION_RATE, CONVERSION_RATE_KG_LBS } from 'config/calculator';
import { UnitDimension, UnitWeight } from 'enums/calculator';
import { NilNumber } from 'interfaces';

export const roundNumber = (
  number: NilNumber,
  precision: number = 2,
  defaultValue: number = 0,
): number => {
  const newNumber = typeof number === 'string' ? Number(number) : number;
  const repeated = '0'.repeat(precision);
  const precisionNumber = Number(`1${repeated}`);
  if (newNumber && !Number.isNaN(newNumber)) {
    return Math.round(newNumber * precisionNumber) / precisionNumber;
  }

  return defaultValue;
};

export const isValidNumber = (number: NilNumber, allowZero = false): boolean => {
  const newNumber = typeof number === 'string' ? Number(number) : number;
  if (allowZero) {
    return !Number.isNaN(newNumber) && Number(newNumber) >= 0;
  }
  return !Number.isNaN(newNumber) && Number(newNumber) > 0;
};

export const convertTo = (value: number, unit: UnitDimension = UnitDimension.MM) => {
  const result = unit === UnitDimension.MM ? value * CONVERSION_RATE : value / CONVERSION_RATE;
  return roundNumber(result);
};

export const convertWeightTo = (value: number, unit: UnitWeight = UnitWeight.KG) => {
  // eslint-disable-next-line max-len
  const result = unit === UnitWeight.KG ? value / CONVERSION_RATE_KG_LBS : value * CONVERSION_RATE_KG_LBS;
  return roundNumber(result);
};
